import React from 'react';
import '../../styles/mfw.scss';
import { Link } from 'react-router-dom';

function Redcarpet() {
const immagini = [
{ type: 'video', source: '/images/RedCarpet/MeganVideo.mov',title: [""], className: ""},
{ type: 'image', source:  '/images/RedCarpet/elisa.png', title: [""], className: ""},
{ type: 'image', source:  '/images/RedCarpet/Augustina.jpg', title: [""], className: ""},
{ type: 'image', source:  '/images/RedCarpet/MeganRedCarpet_1.jpeg', title: [""], className: "" },
{ type: 'image', source:  '/images/RedCarpet/MeganRedCarpet_2.jpeg', title: [""], className: "" },
{ type: 'image', source:  '/images/RedCarpet/MeganRedCarpet_3.jpeg', title: [""], className: "" },
{ type: 'image', source:  '/images/RedCarpet/MeganRedCarpet_4.jpeg', title: [""], className: ""},
{ type: 'image', source:  '/images/RedCarpet/MeganRedCarpet_5.jpeg', title: [""], className: ""},
];

return (
    <section className="magazine">
      <div className="image-grid">
        {immagini.map((item, index) => (
          <div key={index} className={`image-grid__item ${item.className}`}>
            <Link to={item.link}>
              {item.type === 'image' ? (
                <img src={item.source} alt={item.title.join(' ')} />
              ) : (
                <video autoPlay controls muted loop playsInline>
                  <source src={item.source} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
              <h3>
                {item.title.map((line, i) => (
                  <span key={i}>
                    {line}
                    {i < item.title.length - 1 && <br />}
                  </span>
                ))}
              </h3>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Redcarpet;